import consumer from "./consumer"

consumer.subscriptions.create("MessagesChannel", {
  connected(e) {
    // Called when the subscription is ready for use on the server
    // console.log('MessagesChannel connected', e);
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
    // console.log('MessagesChannel disconnected');
  },

  received(data) {
    // Called when there's incoming data on the websocket for this channel
    // console.log('MessagesChannel received:', data);
    App.emit(data.event_name, data.payload);
  }
});
